import { Box, Typography } from "@mui/material";

const GooglePlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
  </svg>
);

const AppStoreIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const StoreButton = ({
  store,
  href,
  variant = "default"
}) => {
  const isGoogle = store === "google";
  const isEntregador = variant === "entregador";

  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.75rem",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.75rem",
    border: "none",
    cursor: "pointer",
    textDecoration: "none",
    transition: "all 0.2s ease",
    backgroundColor: isEntregador
      ? "var(--background-color2)"
      : "#EEB547",
    color: isEntregador
      ? "var(--text-color0)"
      : "#fff",
    "&:hover": {
      opacity: 0.85,
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  };

  return (
    <Box
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={buttonStyle}
    >
      {isGoogle ? <GooglePlayIcon /> : <AppStoreIcon />}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Typography
          variant="caption"
          sx={{ fontSize: "0.65rem", opacity: 0.9, lineHeight: 1 }}
        >
          {isGoogle ? "Disponível no" : "Baixe na"}
        </Typography>
        <Typography
          variant="body2"
          sx={{ fontSize: "0.85rem", fontWeight: 600, lineHeight: 1 }}
        >
          {isGoogle ? "Google Play" : "App Store"}
        </Typography>
      </Box>
    </Box>
  );
};

export default StoreButton;
